@if (profileService.profile$ | async; as profile) {
  <ng-template
    appComponentsHost
    profileData="{{profile}}"
    componentName="TilePage"
    moduleName="ContentPage">
  </ng-template>
}
